// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"158":"f35ff399","427":"b56edfdd","626":"721d4b1b","950":"ad9d7f38"}[chunkId] + ".chunk.css";
};